export const confirmNewPassword = async (email) => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/confirmNewPassword";
      let password1 = document.getElementById("confirm-new-password1").value;
      let password2 = document.getElementById("confirm-new-password2").value;
      let currentLoc = new URL(window.location.href).searchParams;
      let resetId = currentLoc.get("id");
      let email = currentLoc.get("email");
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({password1:password1,password2:password2,resetId:resetId,email:email})
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };